import React from "react";

import { AbstractField, AbstractFieldProps } from "./AbstractField";
import { PasswordInput } from "./PasswordInput";

import style from "./PasswordInput.module.scss";

export interface PasswordFieldProps extends Omit<AbstractFieldProps, "type" | "component" | "render" | "children"> {}

export const PasswordField: React.FC<PasswordFieldProps> = ({ className, ...fieldProps }) => (
  <AbstractField component={PasswordInput} className={{ input: style.input, ...className }} {...fieldProps} />
);
